/**
 * BUG-102 / ADR-025 — what a social post's status means to a person.
 *
 * CCM now holds a scheduled post until 15 minutes before its time, as
 * `approved` with a `scheduled_at`, and only then hands it to Buffer or
 * Zernio (`scheduled`, with the provider's post id). Both are "Scheduled"
 * to a person; the handed-off one says so, because it is the one that can
 * no longer be edited — only cancelled.
 */
import { isHandedOff as isHandedOffShared } from "@shared/social-handoff";

export const STATUS_LABEL: Record<string, string> = {
  draft: "Draft",
  approved: "Approved",
  scheduled: "Scheduled",
  published: "Published",
  posted: "Posted",
  cancelled: "Cancelled",
  failed: "Failed",
};

interface StatusFields {
  status: string;
  scheduled_at: string | null;
  dispatch_post_id: string | null;
}

/** With Buffer or Zernio — the rule the API enforces (`@shared/social-handoff`). */
export function isHandedOff(row: StatusFields): boolean {
  return isHandedOffShared(row.status, row.dispatch_post_id);
}

/**
 * The status a post is grouped under in the calendar's filter chips: the
 * same rule as its label, so a held post (approved + a time) is found under
 * Scheduled, where its label says it is.
 */
export function socialStatusKey(row: StatusFields): string {
  if (row.status === "approved" && row.scheduled_at) return "scheduled";
  return row.status;
}

export function socialStatusLabel(row: StatusFields): string {
  if (row.status === "approved" && row.scheduled_at) return "Scheduled";
  if (isHandedOff(row)) return "Scheduled · handed off";
  return STATUS_LABEL[row.status] ?? row.status;
}
